import React, { useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { LIGHT_AQUA, LIGHT_BLUE } from '@wave-engagement/wave-react';
import { listLeaderboard } from '../../api';
import { useAlerts } from '../../alerts';

const Leaderboard = () => {
  const { setError, clearErrors } = useAlerts();
  const [userCampaigns, setUserCampaigns] = useState([]);

  useEffect(() => {
    loadLeaderboard();
    return () => clearErrors();
  }, []);

  const loadLeaderboard = () => {
    listLeaderboard().then(userCampaigns => {
      setUserCampaigns(userCampaigns);
    }).catch(error => {
      setError(error ?? 'Unable to load leaderboard. Please try again.');
    });
  }

  return (
    <div>
      <Typography variant='h1' gutterBottom style={{ marginTop: '1em', marginBottom: '1em' }}>Leaderboard</Typography>

      {userCampaigns.map((userCampaign, index) => (
        <Grid container key={index} style={{ backgroundColor: index % 2 === 0 ? LIGHT_BLUE : LIGHT_AQUA, width: '100%', marginBottom: 5, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Grid item xs={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant='h2' style={{ width: 70, color: 'black', fontSize: 50, textAlign: 'center' }}>{index + 1}</Typography>
          </Grid>

          <Grid item xs={6} style={{ flex: 1, paddingLeft: 10 }}>
            <Typography variant='h3' style={{ color: 'black' }}>{userCampaign.getUser().getScreenName() ?? userCampaign.getUser().getShortenedName()}</Typography>
          </Grid>
          <Grid item xs={3} style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <Typography variant='h4' sx={{ color: 'black', textAlign: 'right', marginRight: '10px', fontSize: { xs: '15px', sm: '20px', md: '30px' } }}>{userCampaign.getPointsAwarded()} pts</Typography>
          </Grid>
        </Grid>
      ))}
    </div>
  );
}
export default Leaderboard;